import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormGroupDirective } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConferenceRoomViewModel, ConvertToEventViewModel, PaperSubmissionSummaryViewModel, ScheduledEventViewModel, UpdateEventFromScheduleViewModel } from 'src/app/_models/generatedModels';
import { AdminCallForPapersService, AdminConferenceSettingsService, ConferenceSchedulerService, OrganizationService } from 'src/app/_services/generatedServices';
import { ToasterService } from 'src/app/_services/toaster.service';
import { OrganizationAdminContainerComponent } from '../../../organization-admin-container.component';

@Component({
  selector: 'bxl-convert-submission-modal',
  templateUrl: 'convert-submission-modal.component.html',
})
export class ConvertSubmissionModalComponent implements OnInit {
  initialized = false;
  submitComplete: Promise<{}> | undefined;
  errorMessage = '';
  @Input() paper: PaperSubmissionSummaryViewModel;
  @Input() mergeWith: PaperSubmissionSummaryViewModel[];
  @Input() conferenceId: any;
  @Input() organizationId: any;
  @ViewChild('myForm') myForm: FormGroupDirective;
  model: ConvertToEventViewModel;
  dayLabels: string[];
  rooms: ConferenceRoomViewModel[];
  roomsToDisplay: ConferenceRoomViewModel[];

  constructor(private activeModal: NgbActiveModal, private adminCFP: AdminCallForPapersService, private organizationService: OrganizationService, private toaster: ToasterService, private conferenceSchedulerService: ConferenceSchedulerService) {}

  ngOnInit(): void {
    this.model = new ConvertToEventViewModel();

    this.model.title = this.paper.title;
    this.model.dayIndex = 0;
    this.model.durationInMins = this.paper.anticipatedDurationMins;
    this.model.mergeWith = this.mergeWith?.map((x) => x.id);

    if (this.mergeWith && this.mergeWith.length > 0) {
      this.model.title = '';
    }

    console.log(this.paper);
    console.log(this.mergeWith);

    this.initialized = true;
    this.organizationService.getRoomsForConference(this.conferenceId).subscribe((rooms) => {
      this.organizationService.getDayLabelsForConference(this.conferenceId).subscribe((result) => {
        this.dayLabels = result;
        this.rooms = rooms;
        this.roomsToDisplay = this.rooms.filter((x) => !x.specificDates || x.specificDates.length == 0 || x.specificDates.find((y) => y == this.dayLabels[this.model.dayIndex]));
      });
    });
  }

  updateDay(evt) {
    console.log(evt);
    this.roomsToDisplay = this.rooms.filter((x) => !x.specificDates || x.specificDates.length == 0 || x.specificDates.find((y) => y == this.dayLabels[this.model.dayIndex]));
  }

  onCancel() {
    this.activeModal.dismiss();
  }

  save() {
    this.errorMessage = '';
    this.myForm.form.markAllControlsDirty();

    if (!this.myForm.valid) {
      this.toaster.error('Please fill out all required fields', 'Error');
      return;
    }

    this.submitComplete = new Promise((resetButton: any, reject) => {
      this.adminCFP.convertToEvent(this.organizationId, this.conferenceId, this.paper.id, this.model).subscribe(
        (result) => {
          resetButton();
          if (result) {
            this.activeModal.close(result);
          }
        },
        (error) => resetButton()
      );
    });
  }
}
